ft.app.config(['uibDatepickerPopupConfig', function (uibDatepickerPopupConfig) {
    uibDatepickerPopupConfig.closeText = 'Sluiten';
    uibDatepickerPopupConfig.currentText = 'Vandaag';
    uibDatepickerPopupConfig.clearText = 'Wis';
}]);